module.exports = __webpack_public_path__ + "img/zhineng_youtu_er.9ed03370.png";